<div class="h-dvh flex bg-white flex-col">
  @if (!hideBackButton) {
    <div
      class="auth-toolbar bg-black min-h-11 md:min-h-[80px] w-full flex items-center justify-between px-4">
      <app-back-button class="text-headline-5-medium text-white" (click)="back()" />
      <!-- <img alt="Drvn Logo" src="/drvn-logo.svg" class="max-h-[50px] ml-auto" /> -->
    </div>
  }

  <div
    class="flex flex-col items-center flex-grow overflow-auto"
    [class.md:!pt-20]="hideBackButton">
    <div
      class="px-10 mt-8 max-md:mt-6 mb-12 pb-12 w-full rounded-[25px] max-w-[560px] flex flex-col justify-center max-md:justify-start flex-grow md:flex-grow-0 md:justify-start md:border md:border-dividers md:shadow-xs">
      <img alt="Drvn Logo" src="/logo-carnival-login.png" class="mx-auto max-h-[120px]" />
      <router-outlet />
    </div>
    <div class="flex flex-col items-center mt-auto">
      <img alt="Drvn Logo" src="/drvn-logo-black.png" class="max-h-[30px] mb-3" />
      <div class="text-black text-center mb-6 max-md:text-caption-1">
        © {{ currentYear() }} Moveo Technologies Corp. drvn
        <br />
        All Rights Reserved.
      </div>
      <div class="flex justify-between items-center w-full mb-6 max-mdtext-caption-1">
        <a class="text-primary text-underline" href="https://www.drvn.com" target="_blank">
          drvn.com
        </a>
        <a
          class="text-primary text-underline"
          href="https://www.drvn.com/privacy-policy"
          target="_blank">
          Privacy
        </a>
        <a class="text-primary text-under" href="https://www.drvn.com/terms-of-use" target="_blank">
          Terms of Use
        </a>
      </div>
    </div>
  </div>
</div>
